<template>
  <div 
    v-if="slug !== null && slug !== 'error' && pageData"
    class="GemeenteBeknopt">

    <HeaderSection 
      :title="`Gemeente: ${title}`"
      :closeLinkTo="{ name: 'list-gemeenten' }">
      <p>
        {{ definition }}
      </p>
    </HeaderSection>

    <ContentSection>
      <SectionHeader label="Verhalen" />
      
      <p v-if="items.length === 0">
        Er zijn nog geen verhalen verbonden aan deze gemeente. <br />
        Heb jij een goed verhaal om te delen? <br />
        <Link :to="{ name: 'page-aanmaken' }" label="Laat het ons weten!" arrow />
      </p>
    </ContentSection>
    <List 
      :items="items" 
      :sortingBy="sortingBy" 
      type="project"
      readmore="zoom" />
    
  </div>
</template>

<script>
import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';
import SectionHeader from '@/components/section/Header';
import ContentSection from '@/components/section/ContentSection';
import Link from '@/components/Link';

export default {
  name: 'GemeenteBeknopt',
  components: {
    List,
    HeaderSection,
    SectionHeader,
    ContentSection,
    Link
  },
  data() {
    return {
      slug: null,
      sortingBy: [
        {
          key: 'name',
          label : 'A-Z'
        }
      ]
    }
  },
  computed: {
    pageData() {
      return this.$store.getters.getGemeenteBySlug({
        slug: this.slug
      });
    },
    title() {
      return this.pageData.name;
    },
    definition() {
      return this.pageData.summary;
    },
    items() {
      let items = this.$store.getters.getProjectsByGemeente({id: this.pageData.id});
      items.forEach((item) => {
        item.to = { name: 'project-beknopt', params: { slug: item.slug } };
        return item;
      });
      return items;
    }
  },
  created() {
    this.slug = this.$route.params.slug 
      ? this.$route.params.slug 
      : 'error';

    if (this.title && this.$store.map) {
      let gemeente = this.title.replace('Gemeente ', '');
      this.$store.map.setFilter('gemeenten', ['all', ['==', 'GM_NAAM', gemeente]])
    }
  },
  destroyed() {
    if (this.$store.map) {
      this.$store.map.setFilter('gemeenten', ['all', ['==', 'GM_NAAM', 'off']])
    }
  }
}
</script>

<style lang="scss">
  .GemeenteBeknopt {
    position: relative;
    display: flex;
    flex-direction: column;

    .ContentSection {
      margin-bottom: 0;
      .SectionHeader {
        margin-bottom: 0;
      }
    }
    .List__items {
      padding-top: 16px !important;
    }
  }
</style>
